module.exports = __webpack_public_path__ + "static/media/joker.695472e0.png";